<template>
  <div style="padding-bottom: 80px">
    <div class="courseBox">
      <div class="title">
        <div class="t0">
          <img :src="courseInfo.cimage" alt="" />
        </div>

        <div class="t1">
          <div class="t2">{{ courseInfo.cname }}</div>
          <div class="t3">学时：{{ courseInfo.ccredithour }}学时</div>
          <div class="t3">是否考试：{{ courseInfo.isExam == '01' ? '否' : '是' }}</div>
        </div>
      </div>
      <div class="t4">
        培训方式：{{
          courseInfo.cmode == '01'
            ? '在线'
            : courseInfo.cmode == '02'
            ? '面授'
            : courseInfo.cmode == '03'
            ? '混合（在线+面授）'
            : courseInfo.cmode == '04'
            ? '外派'
            : ''
        }}
      </div>
      <div class="t4">授课老师：{{ courseInfo.teacherName }}</div>
      <div class="t4">学习时间：{{ courseInfo.cstarttime }} — {{ courseInfo.cendtime }}</div>
    </div>

    <div class="courseList">
      <div class="courseTips">课程章节</div>

      <div class="cbox" v-for="(item, index) in courseList" :key="item.id">
        <div class="cIndex">第{{ index + 1 }}节</div>
        <div class="c2">{{ item.cwName }}</div>
        <div class="c3">
          <div class="c4">学时：{{ item.creditNum }}学时</div>
          <div class="c5" @click="goSk(item)">
            <div class="c6">
              <img class="c6" src="../../assets/images/sk.png" alt="" />
            </div>
            <div>试看</div>
          </div>
        </div>
      </div>
         <div class="load-more" v-if="courseList.length > 0 && !isNoMoreData && !loding">
        <div @click="loadMore" style="color: #999">点击加载更多</div>
      </div>
      <div class="no-more" v-if="isNoMoreData">没有更多数据了</div>
    </div>
    </div>

    <!-- <div class="hejBox" v-if="classEnrolStatus!=='01'">
      <div class="titol" v-if="courseInfo.cprice !== undefined"><span style="font-size: 14px" >合计：¥</span>{{ courseInfo.cprice.toFixed(2) }}</div>

      <div class="gmBtn">立即购买</div>
    </div> -->
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { toCourseDetail } from '@/api/classDetail';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      totolNum: 0,
      courseInfo: {},
      courseList: [],
      classEnrolStatus:'02',
      isNoMoreData: false, // 是否没有更多数据
       pageNum:1,
         pageSize:10,
         total:''
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
       loadMore() {
      if (!this.isNoMoreData) {
        this.pageNum++;
    
        this.getList(this.$route.query.id)
      }
    },
    //试看
    goSk(item) {
      this.$router.push({
        path: '/tryPlaying',
        query: {
          id: item.cwId,
          name:this.courseInfo.cname
        }
      });
    },
    getList(id) {
      const data={
         courseId: id ,
         pageNum:this.pageNum,
         pageSize:this.pageSize
      }
      toCourseDetail(data).then(res => {
        if(this.pageNum==1){
        this.courseList = res.data.data.couCwList.rows;

        }else{
          this.courseList =[...this.courseList,...res.data.data.couCwList.rows]
        }
        this.total=res.data.data.couCwList.total
        this.isNoMoreData=this.courseList.length>=this.total
        this.courseInfo = res.data.data.course;
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getList(this.$route.query.id);
    this.classEnrolStatus = this.$route.query.classEnrolStatus//01是不展示购买按钮
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.courseBox {
  margin-top: 46px;
  width: 100%;
  height: 200px;
  background: #fff;
  padding: 20px 15px 0 15px;
  .title {
    display: flex;
    .t0 {
      width: 110px;
      height: 88px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 8px;
      }
    }
    .t1 {
      margin-left: 10px;
      margin-bottom: 6px;
      .t2 {
        margin-top: 5px;
        color: #000000;
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 8px;
      }
      .t3 {
        margin-bottom: 4px;
        color: #333333;
        font-size: 13px;
      }
    }
  }
  .t4 {
    margin-top: 6px;
    color: #333333;
    font-size: 13px;
  }
}
.courseList {
  padding: 0 15px;
}
.courseTips {
  margin-top: 24px;
  margin-bottom: 12px;
  color: #333333;
  font-size: 17px;
  font-weight: 600;
}
.cbox {
  width: 100%;
  height: 120px;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 10px;
  padding: 20px 15px;
  .cIndex {
    width: 48px;
    height: 24px;
    background: #f6f8fa;
    border-radius: 4px 4px 4px 4px;
    text-align: center;
    line-height: 24px;
    color: #666666;
    font-size: 13px;
  }
  .c2 {
    width: 320px;
    margin-top: 10px;
    color: #333333;
    font-size: 15px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .c3 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .c4 {
      color: #999999;
      font-size: 13px;
    }
    .c5 {
      margin-top: 4px;
      display: flex;
      width: 74px;
      height: 32px;
      background: #f3f3f5;
      border-radius: 27px 27px 27px 27px;
      color: #2a70f2;
      font-size: 13px;
      align-items: center;
      padding-left: 14px;
      img {
        margin-top: 2px;
        width: 16px;
        height: 16px;
      }
    }
  }
}

.hejBox {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 15px;
  background: #ffffff;
  justify-content: space-between;
  .titol {
    color: #ff2d31;
    font-size: 22px;
  }
  .gmBtn {
    width: 110px;
    height: 40px;
    background: linear-gradient(90deg, #ff8285 0%, #e74f52 100%);
    border-radius: 8px 8px 8px 8px;
    text-align: center;
    line-height: 40px;
    color: #ffffff;
    font-size: 14px;
  }
}
.load-more {
  text-align: center;
  margin-top: 20px;
}

.no-more {
  text-align: center;
  font-size: 14px;
  color: #999;
  margin-top: 20px;
}

</style>
